// DO NOT EDIT THIS FILE

import gql from 'graphql-tag';

export const COLLAB_ALL_TEAMS = gql`
query collabAllTeams($search: String) {
  collab: Teams(employees_User_FirstName_Icontains: $search) {
    edges {
      node {
        id
        employees(user_FirstName: $search, user_Status_Verified: true) {
          edges {
            node {
              id
              user {
                id
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
}
`;
